module.exports = __webpack_public_path__ + "img/aerc.4778f2a1.jpg";